import { css } from "lit-element";

export const style = css`
	:host {
		display: flex;
		flex-direction: row;
		height: 100vh;
		width: 100%;
	}

	.inner {
		width: 50%;
		margin: auto;
	}
	.column.left {
		height: 100vh;

		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		background-image: url("images/background_auth.svg");
		background-color: var(--auth-bg-color);

		align-items: center;
		justify-content: center;
	}
	.column.right {
		background-color: var(--app-white);
	}

	img {
		max-width: 50%;
		display: block;
		margin: auto;
	}

	@media screen and (max-width: 768px) {
		.column.left {
			width: 100%;
			position: fixed;
		}
		.inner {
			display: block;
			position: relative;
			width: 80%;
		}
		img {
			max-width: 80%;
		}
	}
`;
